import * as React from 'react';

const CheckCircleFilled64 = ({ title, titleId, ...props }) => /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 64 64", width: 64, height: 64, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M32 5.33C17.27 5.33 5.33 17.27 5.33 32c0 14.73 11.94 26.67 26.67 26.67 14.73 0 26.67-11.94 26.67-26.67C58.67 17.27 46.73 5.33 32 5.33Zm-2.67 35.46-9.06-9.06 2.12-2.12 6.94 6.94L41.6 24.28l2.12 2.12-14.39 14.39Z"
  }
));
CheckCircleFilled64.Size = 64;
CheckCircleFilled64.Title = "CheckCircleFilled";

export { CheckCircleFilled64 as default };
